import cx from 'classnames';
import React, { FunctionComponent, useState } from 'react';
import SubNavigationHeading from './SubNavigationHeading';

type Props = {
    children?: React.ReactNode;
    heading: string;
    initialExpanded?: boolean;
};

const SubNavigation: FunctionComponent<Props> = ({ children, heading, initialExpanded = true }) => {
    const [expanded, setExpanded] = useState(initialExpanded);
    const onClickExpand = () => {
        setExpanded((prevExpanded) => !prevExpanded);
    };
    return (
        <div className={cx(['submenu', { 'submenu--expanded': expanded }])}>
            <button className="submenu__button" onClick={onClickExpand} aria-expanded={expanded}>
                Fäll ut
            </button>
            <SubNavigationHeading heading={heading} />
            {children}
        </div>
    );
};

export default SubNavigation;
